import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-hotel-link-intrustion',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './hotel-link-intrustion.component.html',
  styleUrls: ['./hotel-link-intrustion.component.scss']
})
export class HotelLinkIntrustionComponent {

}
